@if (results) {
  showing {{ results.totalItems | number : '1.0-0' }} {{ filtered === true ? 'filtered' : '' }} {{ objectName}}
  @if ($any(results).totalUnits > 0) {
    and {{
    $any(results).totalUnits | number : '1.0-0' }} units
    @if ($any(results).rangeUnits > 0) {
      with {{
      $any(results).rangeUnits | number : '1.0-0' }} in date range
    }
  }
}
